import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const CalmarTool = () => {
    const [pr, setPr] = useState(30);
    const [md, setMd] = useState(15);

    const c = md > 0 ? pr / md : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Calmar Ratio</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Annual Return %" value={pr} onChange={setPr} />
                <InputGroup label="Max Drawdown %" value={md} onChange={setMd} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-purple">
                    <div className="tct-data-row"><span className="tct-label">Calmar Ratio</span><span className="tct-value val-blue big-value">{c.toFixed(2)}</span></div>
                </div>
            </div>
            <InfoBox
                title="Calmar Ratio: Measuring Return vs Drawdown"
                meta="Learn how Calmar ratio evaluates trading strategies based on return and drawdown"
                sections={[
                { title: "Introduction", content: "Calmar ratio measures return relative to maximum drawdown." },
                { title: "Example", content: "Annual return = 30%<br>Max drawdown = 15%<br><br>Calmar ratio = 2.<br><br>Higher values indicate better strategies." }
                ]}
            />
        </div>
    );
};

export default CalmarTool;
